import axios from 'axios';
const API_URL = 'https://imara-production-91ab.up.railway.app';
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically add token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);

// Moods
export const logMood = (data) => api.post('/moods/', data);
export const getMyMoods = () => api.get('/moods/');
export const getMoodSummary = () => api.get('/moods/summary');

// Streaks
export const createStreak = (data) => api.post('/streaks/', data);
export const getMyStreaks = () => api.get('/streaks/');
export const checkInStreak = (id) => api.post(`/streaks/${id}/checkin`);
export const resetStreak = (id) => api.post(`/streaks/${id}/reset`);

// Devotionals
export const getTodayDevotional = () => api.get('/devotionals/today');
export const getRandomDevotional = () => api.get('/devotionals/random');

// Music
export const getMusicByMood = (score) => api.get(`/music/recommendations/${score}`);

// Community
export const getPosts = () => api.get('/community/posts');
export const createPost = (data) => api.post('/community/posts', data);
export const replyToPost = (id, data) => api.post(`/community/posts/${id}/reply`, data);
export const likePost = (id) => api.post(`/community/posts/${id}/like`);

// Profile
export const getMyProfile = () => api.get('/profile/me');
export const updateProfile = (data) => api.put('/profile/me', data);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// M-Pesa
export const mpesaPay = (data) => api.post('/mpesa/pay', data);
export default api;